import { Parser } from '~/api';
import RequestService from './request';

interface PerformGameSwitchRequest {
    egg_id: string | number;
    take_backup: boolean;
    environment: Record<string, string>;
    // Staff-only move overrides (ignored by the API unless the caller is staff).
    bypass_requirements?: boolean;
    target_node_id?: string | number;
    allocation_id?: string | number;
    additional_allocation_ids?: (string | number)[];
    // Cross-node consent.
    acknowledge_ip_change?: boolean;
    acknowledge_backups_deleted?: boolean;
    acknowledge_dedicated_ticket?: boolean;
    acknowledge_dedicated_reassigned?: boolean;
}

class SwitchGameService {
    getAll(): Promise<ListResponse> {
        return RequestService.get('/servers/:server/switch-game').then(Parser.parse);
    }

    getCurrentVariables(): Promise<ListResponse> {
        return RequestService.get('/servers/:server/switch-game/current-variables').then(Parser.parse);
    }

    getEggVariables(eggId: number): Promise<ListResponse> {
        return RequestService.get(`/servers/:server/switch-game/eggs/${eggId}/variables`).then(Parser.parse);
    }

    validateVariables(eggId: string | number, environment: Record<string, string>): Promise<{ errors: Record<string, string> }> {
        return RequestService.post(`/servers/:server/switch-game/eggs/${eggId}/validate`, { environment });
    }

    perform(data: PerformGameSwitchRequest): Promise<void> {
        return RequestService.post('/servers/:server/switch-game', data);
    }
}

export default new SwitchGameService();
